import React, { useState } from "react";

import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
} from "@mui/material";

import { capitalizeFirstLetter } from "Constant/string";

const RETENTION_OPTIONS = [
    "forever",
    "1",
    "7",
    "15",
    "30",
    "60",
    "90",
    "180",
    "custom",
];

const Content = ({ name, setName, retentionDays, setRetentionDays }) => {
    const [isManualInput, setIsManualInput] = useState(false);

    return (
        <Stack spacing={2} sx={{ p: 3 }}>
            <TextField
                name="name"
                label="Name"
                variant="outlined"
                onChange={(event) => setName(event.target.value)}
                value={name}
                placeholder="Name"
                fullWidth
            />
            {isManualInput ? (
                <TextField
                    label="Retention Days"
                    type="number"
                    fullWidth
                    value={retentionDays}
                    onChange={({ target: { value } }) => {
                        const num = Number(value);
                        if ((num > 0 && num <= 180) || value === "") {
                            setRetentionDays(value);
                        }
                    }}
                />
            ) : (
                <FormControl fullWidth>
                    <InputLabel id="meta-custom-audience-retention-label">
                        Retention Days
                    </InputLabel>
                    <Select
                        labelId="meta-custom-audience-retention-label"
                        label="Retention Days"
                        required
                        value={retentionDays}
                        onChange={({ target: { value } }) => {
                            setRetentionDays(value === "custom" ? "1" : value);
                            setIsManualInput(value === "custom");
                        }}
                    >
                        {RETENTION_OPTIONS.map((value) => (
                            <MenuItem value={value} key={value}>
                                {capitalizeFirstLetter(value)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </Stack>
    );
};

export default Content;
